export const CONFIRM_USER_REQUEST = 'CONFIRM_USER_REQUEST';
export const CONFIRM_USER_RESULT = 'CONFIRM_USER_RESULT';

export const CONFIRM_USER_VERIFICATE_CODE_REQUEST = 'CONFIRM_USER_VERIFICATE_CODE_REQUEST';
export const CONFIRM_USER_VERIFICATE_CODE_RESULT = 'CONFIRM_USER_VERIFICATE_CODE_RESULT';